import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SERVICE_TYPE_LABELS, type ServiceType } from '@/types';

const moreServices: ServiceType[] = [
  'ventilation',
  'refrigeration',
  'water_heater',
  'duct_cleaning',
  'insulation',
];

export function Footer() {
  const { t } = useTranslation('common');

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <Search className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">HVACMap</span>
            </Link>
            <p className="text-gray-400 max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">{t('services')}</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/services/hvac" className="hover:text-white">
                  {t('footer.hvacServices')}
                </Link>
              </li>
              <li>
                <Link to="/services/plumbing" className="hover:text-white">
                  {t('footer.plumbingServices')}
                </Link>
              </li>
              <li>
                <Link to="/services/electrical" className="hover:text-white">
                  {t('footer.electricalServices')}
                </Link>
              </li>
              <li>
                <Link to="/services/heating" className="hover:text-white">
                  {t('footer.heatingServices')}
                </Link>
              </li>
              <li>
                <Link to="/services/cooling" className="hover:text-white">
                  {t('footer.coolingServices')}
                </Link>
              </li>
            </ul>
          </div>

          {/* More Services */}
          <div>
            <h3 className="font-semibold mb-4 opacity-0">More</h3>
            <ul className="space-y-2 text-gray-400">
              {moreServices.map((type) => (
                <li key={type}>
                  <Link to={`/services/${type}`} className="hover:text-white">
                    {SERVICE_TYPE_LABELS[type]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* For Pros */}
          <div>
            <h3 className="font-semibold mb-4">{t('footer.forPros')}</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/signup" className="hover:text-white">
                  {t('listYourBusiness')}
                </Link>
              </li>
              <li>
                <a
                  href="https://hvacfrontdesk.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  {t('footer.getHvacFrontdesk')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} HVACMap. {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-400">
            <Link to="/privacy" className="hover:text-white">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms" className="hover:text-white">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
